window.__tabValues = window.__tabValues || {}
let _tabValues = window.__tabValues

const initTabs = $root => {
  const id = $root.data('id')

  const filterByCurrent = (_, elem) => {
    return $(elem).closest('.admin-tabs').is($root)
  }

  const setCurrentTab = tabName => {
    id && (_tabValues[id] = tabName)

    $root
      .find(`.admin-tabs__tab[data-tab="${tabName}"]`)
      .filter(filterByCurrent)
      .toggleClass('is-active', true)

    $root
      .find(`.admin-tabs__tab[data-tab!="${tabName}"]`)

      .filter(filterByCurrent)
      .toggleClass('is-active', false)

    $root
      .find(`.admin-tabs__content[data-tab="${tabName}"]`)

      .filter(filterByCurrent)
      .toggleClass('is-active', true)

    $root
      .find(`.admin-tabs__content[data-tab!="${tabName}"]`)
      .filter(filterByCurrent)
      .toggleClass('is-active', false)
  }

  $root
    .find('.admin-tabs__tab')
    .filter(filterByCurrent)
    .on('click', event => {
      const $t = $(event.currentTarget)
      setCurrentTab($t.data('tab'))
    })

  let current = null
  if (id && (current = _tabValues[id])) {
    setCurrentTab(current)
  } else {
    const curr = $root.find('.admin-tabs__content:first').data('tab')
    setCurrentTab(curr)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  $('.admin-tabs').each(function () {
    initTabs($(this))
  })
})
